module.exports = __webpack_public_path__ + "static/clock-bfe6b734e55b5968738128a16b851617.png";